import Vue from "vue";
import router from "@/router/index";
import Home from "@/views/templates/headerSearch/Home.vue";
import Login from "@/views/templates/headerSearch/Login.vue";
import Validation from "@/views/templates/headerSearch/Validation.vue";
import Error from "@/views/templates/headerSearch/Error.vue";
import NotSupported from "@/views/templates/headerSearch/NotSupported.vue";
import AuthError from "@/views/templates/headerSearch/AuthError.vue";
import Mantainance from "@/views/templates/headerSearch/Mantainance.vue";
import { mapGetters } from "vuex";
import SurveyCompiled from "@/views/templates/headerSearch/SurveyCompiled.vue";
export default Vue.extend({
    computed: {
        ...mapGetters('auth', {
            nextRoute: "getNextRoute"
        })
    },
    props: {
        templateName: String,
        customerCode: String,
        templateConfig: {}
    },
    data() {
        return {};
    },
    mounted() {
        router.addRoute({ path: '/:customerCode', name: 'HomeTemplate', component: Home, props: { templateName: this.templateName } });
        router.addRoute({ path: '/:customerCode/open/:codeTag', name: 'Autopilot', component: Home, props: { templateName: this.templateName } });
        router.addRoute({ path: '/:customerCode/mantainance', name: 'Mantainance', component: Mantainance, props: true });
        router.addRoute({ path: '/:customerCode/authError', name: 'AuthError', component: AuthError, props: true });
        router.addRoute({ path: '/:customerCode/notSupported', name: 'NotSupported', component: NotSupported, props: true });
        router.addRoute({ path: '/:customerCode/error', name: 'Error', component: Error, props: true });
        router.addRoute({ path: '/:customerCode/validation', name: 'Validation', component: Validation, props: true });
        router.addRoute({ path: '/:customerCode/login', name: 'Login', component: Login, props: true });
        router.addRoute({ path: '/:customerCode/surveyCompiled', name: 'SurveyCompiled', component: SurveyCompiled, props: true });
        let rotta = { name: 'HomeTemplate' };
        if (this.nextRoute) {
            rotta = { path: this.nextRoute };
            this.$store.dispatch("auth/setNextRoute", undefined);
        }
        router.push(rotta);
    },
    methods: {},
    components: {
        Home,
        Login,
        Validation,
        Error,
        NotSupported,
        AuthError,
        Mantainance
    },
});
